
/** For any modification refer to Warden ID on products table to add to any array of compatible products
 *  PLEASE CHECK AND MODIFY:
 * - Biolab\wildfire\Canopy\Javascript\ui\helpers\truBlueProductsConstants.js
 * - Biolab\wildfire\Canopy\Helpers\TruBlueHelper.cs 
 * - Biolab\wildfire\Helitack\Jobs\TruBlueAnnualReset.cs
 * - Biolab\scripts\tb-annual-year-reset.sql (**BACKUP FOR MANUAL RUNS**)
**/

export const usProducts = {
  chlorinePool: {
    sanitizers: [26, 84, 85],
    maintOxidizers: [27, 51, 29, 17, 18],
    prevAlgicides: [28, 40, 39, 33],
    maintClarifiers: [], //not required
  },
  saltWaterPool: {
    sanitizers: [82], //Saltwater Sanitizer
    maintOxidizers: [27, 51, 29, 17, 18],
    prevAlgicides: [28, 40, 39, 33, 78],
    maintClarifiers: [], //not required
  },
  mineralSpringsPool: {
    sanitizers: [55], //Mineral Springs Sanitizer
    maintOxidizers: [], // No oxidizer needed
    prevAlgicides: [], //not required
    maintClarifiers: [],
  },
};


export const caProducts = {
  chlorinePool: {
    sanitizers: [86, 93, 182],
    maintOxidizers: [27, 168, 164, 29, 18],
    prevAlgicides: [40, 38, 52],
    maintClarifiers: [],
  },
  saltWaterPool: {
    sanitizers: [82],
    maintOxidizers: [27, 168, 164, 29, 18],
    prevAlgicides: [40, 38, 52],
    maintClarifiers: [],
  },
  mineralSpringsPool: {
    sanitizers: [55],
    maintOxidizers: [], //No oxidizer needed
    prevAlgicides: [], //not required
    maintClarifiers: [],
  },
  synergyPool: {
    sanitizers: [166],  //Synergy tabs
    maintOxidizers: [161, 27, 168, 164, 29, 18],
    prevAlgicides: [], //not required
    maintClarifiers: [],
  },
};
